"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestDeviceImpl = void 0;
const ButtplugDeviceImpl_1 = require("../devices/ButtplugDeviceImpl");
class TestDeviceImpl extends ButtplugDeviceImpl_1.ButtplugDeviceImpl {
    constructor(aName) {
        super(aName, aName);
        this._connected = true;
        this._lastValueWritten = [];
        this._valueToRead = new Map();
    }
    get Connected() {
        return this._connected;
    }
    get LastValueWritten() {
        const value = this._lastValueWritten.shift();
        return value;
    }
    SetValueToRead(aEndpoint, aData) {
        this._valueToRead.set(aEndpoint, aData);
    }
    Connect() {
        return __awaiter(this, void 0, void 0, function* () {
            // noop
            return Promise.resolve();
        });
    }
    Disconnect() {
        this._connected = false;
        this.emit("deviceremoved", this);
    }
    ReadValueInternal(aOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._valueToRead.has(aOptions.Endpoint)) {
                return Promise.resolve(Buffer.from([]));
            }
            const value = this._valueToRead.get(aOptions.Endpoint);
            this._valueToRead.delete(aOptions.Endpoint);
            return Promise.resolve(value);
        });
    }
    WriteValueInternal(aData, aOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            this._lastValueWritten.push([aOptions.Endpoint, aData]);
            return Promise.resolve();
        });
    }
    SubscribeToUpdatesInternal(aOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    ScheduleUpdateOnNextTick(aChr, aData) {
        process.nextTick(() => this.emit("updateReceived", [aChr, aData]));
    }
}
exports.TestDeviceImpl = TestDeviceImpl;
//# sourceMappingURL=TestDeviceImpl.js.map